import { Theme } from '@adecco/base-app/src/constants/themes/defaultTheme/themeType';
import calcrem from '@adecco/base-app/src/utilities/calcrem/calcrem';

const defaultTheme: Theme = {
  aligns: {
    fact: 'center',
    jobFactItem: 'flex-start',
  },
  backgrounds: {
    aboutUs: 'rgb(252, 252, 252)',
    benefit: '#ad0f28',
    cardIconContainer: '#eef2f9',
    checkBox: '#eef2f9',
    circleIcon: '#5cb85c',
    fact: '#ad0f28',
    contact: '#eef2f9',
    faqItem: '#eef2f9',
    input: '#eef2f9',
    inputFocus: '#eef2f9',
    jobListTeaserFooter: 'white',
    logoButton: 'rgb(252, 252, 252)',
    onChangeInput: '#eef2f9',
    phoneWithCountry: '#eef2f9',
    processNumber: 'transparent',
    progressBar: '#eef2f9',
    progressBarDone: 'rgb(92, 184, 92)',
    salaryScale: '#EEF2F9',
    progressBarItem: {
      done: 'transparent',
      current: 'transparent',
      future: '#f8f8f8',
      finished: 'transparent',
    },
    searchBox: 'linear-gradient(90deg, #ad0f28 50%, #ad0f28 100%)',
    smallGhostButton: '#f99f38',
    spacer: '#ad0f28',
    speechBubbleWrapper: '#f99f38',
    tab: 'linear-gradient(-180deg, rgba(238, 238, 238, 0) 0%, rgba(216, 216, 216, 0.16) 100%)',
    teaser: '#eef2f9',
    wrapper: '#eef2f9',
  },
  blendModes: {
    processNumber: 'multiply',
  },
  borders: {
    aboutUs: '1px solid rgba(151, 151, 151, 0.35)',
    backBarLink: '1px solid #e6e6e6',
    backBarLinkBlack: '2px solid #191919',
    black: '1px solid #000',
    bullet: 'none',
    callToAction: '2px solid #f99f38',
    checkBox: '2px solid #afafaf',
    checkMarkDarkGrey: 'none',
    checkMarkPrimary: '1px solid #f99f38',
    circleIconWidth: '0px',
    errorField: '1px solid #f99f38',
    form: 'none',
    helpText: '0.5px solid rgb(175, 175, 175)',
    inputField: 'none',
    link: '1px solid #111',
    logoButton: '1px solid #eee',
    materialDown: 'none',
    panel: 'none',
    progressBar: 'none',
    progressBarItemColor: '#ffffff',
    progressBarItemWidth: '4px',
    radioButton: '0.5px solid #555555',
    radioButtonError: '0.5px solid #f99f38',
    regular: 'none',
    searchButton: 'none',
    secondFooter: '1px solid #c8c7c7',
    smallGhostButton: 'none',
    speechBubbleAfter: '11px 10px 0 10px',
    teaser: 'none',
    twoColTextStyled: '2px solid rgb(173, 15, 40)',
    wrapper: 'none',
  },
  boxShadow: {
    boxShadow: 'none',
    brandBarWrapper: 'none',
    cardInfo: 'none',
    checkBox: 'none',
    callToAction: 'none',
    contact: '0px 4px 6px 0px rgba(0, 0, 0, 0.07)',
    fact: 'none',
    faqItem: 'none',
    faqItemOpen: '0',
    fileField: 'none',
    helpText: 'inset 2px 2px 3px 0 rgba(0, 0, 0, 0.05)',
    imageTeaser: 'none',
    input: 'none',
    inputFocus: 'inset -1px 1px 4px 0px rgba(0, 0, 0, 0.2)',
    materialMid: 'none',
    materialUp: 'none',
    media: 'none',
    mediaWideScreen: 'none',
    pageHead: 'none',
    pageHeadContainer: 'none',
    speechBubbleWrapper: 'none',
  },
  colors: {
    activeBullet: '#ad0f28',
    baseButtonText: '#FFFFFF',
    benefitHeadline: '#ffffff',
    black: '#969696',
    bullet: '#eef2f9',
    cardInfoHeadline: '#750106',
    checkTextError: '#750106',
    contactLink: '#750106',
    error: '#ad0f28',
    fact: '#ffffff',
    faqItemOpenElement: '#750106',
    green: '#7cc67c',
    headline: '#ad0f28',
    infoIconBackground: '#ad0f28',
    infoIconEmphasizedBackground: '#fff',
    infoIconEmphasizedForeground: '#ad0f28',
    infoIconForeground: '#fff',
    infoText: '#750106',
    infoTextIcon: '#aaa',
    inputFieldError: '#f99f38',
    inputText: '#750106',
    jobLink: '#ad0f28',
    jobListItem: '#750106',
    label: '#750106',
    lightBlack: '#1a1919',
    lighterGrey: '#eee',
    lightestGrey: '#f8f8f8',
    lightGrey: '#e6e6e6',
    cvLink: '#3AAEF4',
    location: '#750106',
    medGrey: '#CFCFCF',
    paragraph: '#750106',
    primary: '#f99f38',
    processNumber: '#FFFFFF',
    progressBarIcon: {
      done: '#ad0f28',
      current: '#ad0f28',
      future: '#ad0f28',
      finished: '#FFFFFF',
    },
    progressBarItem: {
      done: '#750106',
      current: '#750106',
      future: '#750106',
      finished: '#750106',
    },
    progressBarItemContent: {
      done: '#ad0f28',
      current: '#ad0f28',
      future: '#ad0f28',
      finished: '#ad0f28',
    },
    requiredStar: '#f99f38',
    rgbblack: '0,0,0',
    smallGhostButton: 'white',
    statusBarYellow: '#ffc15d',
    subline: '#ad0f28',
    success: '#5cb85c',
    text: '#ad0f28',
    textGrey: '#aaa',
    secondaryButton: '#aaa',
    textlink: '#750106',
    twoColParagraph: 'transparent',
    white: '#FFFFFF',
  },
  displays: {
    backToSearchMobileLink: 'inline-block',
    factImage: 'none',
    infoButton: 'column-reverse',
    formLanguage: 'flex',
    jobFactItemValue: 'block',
    jobFactList: 'block',
    processNumber: 'none',
    progressBarDone: 'inline-block',
    searchBox: 'block',
    thankYouTeaserList: 'grid',
  },
  flexDirections: {
    jobFactItemContent: 'column',
  },
  fonts: {
    cardInfoHeadline: 'Open Sans, Helvetica, Arial, sans-serif',
    Copy: 'Open Sans, Helvetica, Arial, sans-serif',
    factSubline: 'Open Sans, Helvetica, Arial, sans-serif',
    formHead: 'Bebas Neue, Helvetica, Arial, sans-serif',
    formHeadWideScreen: 'Bebas Neue, Helvetica, Arial, sans-serif',
    Headline: 'Open Sans, Helvetica, Arial, sans-serif',
    HeadlineBold: 'Bebas Neue, Helvetica, Arial, sans-serif',
    input: 'Open Sans, Helvetica, Arial, sans-serif',
    searchTextField: 'Open Sans, Helvetica, Arial, sans-serif',
  },
  fontSizes: {
    benefitHeadline: calcrem(26),
    benefitHeadlineWideScreen: calcrem(26),
    brandedHeadline: '40px',
    brandedHeadlineWideScreen: '50px',
    button: calcrem(18),
    buttontext: calcrem(28),
    buttonWideScreen: calcrem(24),
    cardIconHeadline: '17px',
    cardImageHeadline: '17px',
    checkboxLabel: '17px',
    checkText: '14px',
    dataBadge: calcrem(19),
    dateParagraph: calcrem(14),
    dateParagraphWideScreen: calcrem(16),
    errorMessageText: '14px',
    errorMessageTextHeading: '17px',
    factHeadline: calcrem(86),
    factListHeadlineWideScreen: '36px',
    factSubline: '22px',
    faqHeadline: '40px',
    faqItemHeadline: '26px',
    faqItemHeadlineWideScreen: '26px',
    faqItemParagraph: '14px',
    formHead: calcrem(18),
    formHeadWideScreen: calcrem(24),
    headline1: '40px',
    headline1WideScreen: '50px',
    headline2: '40px',
    headline2WideScreen: '36px',
    headline3: '26px',
    headline4: '26px',
    headline4Widescreen: '26px',
    headlineTeaser: '26px',
    imageTeasersHeadlineWideScreen: '36px',
    infoText: '12px',
    jobContentHeadlineWideScreen: '36px',
    jobSearchListHeadline: '40px',
    jobSearchListHeadlineWideScreen: '50px',
    jobTeaserDate: '12px',
    label: '14px',
    landingPageHeadline: '40px',
    landingPageHeadlineWideScreen: '50px',
    landingPageParagraph: '16px',
    landingPageParagraphWideScreen: '17px',
    leadFormSectionButton: '30px',
    link: calcrem(18),
    linkList: calcrem(20),
    locationList: '17px',
    logoButtonHeadline: '36px',
    mediaHeadline: '40px',
    mediaHeadlineWideScreen: '36px',
    placeholder: calcrem(18),
    processHeadlineWideScreen: '36px',
    processItemNumber: '17px',
    searchSubmitButton: '20px',
    smallButton: '20px',
    speechBubble: '17px',
    subline: '26px',
    sublineWideScreen: '26px',
    tab: '20px',
    text: '14px',
    textWideScreen: '14px',
    typographyHeadline2: '26px',
    typographyHeadline2WideScreen: '36px',
  },
  fontStyles: {
    infoDropdown: 'italic',
    infoTextText: 'italic',
  },
  fontWeights: {
    button: '600',
    cardImageHeadline: 'bold',
    headline: 'bold',
    landingHeadline: 'bold',
    landingDiscription: '600',
    infoText: 'bold',
    jobFactItem: '600',
    link: '600',
    listParagraph: 'bold',
    locationList: '600',
    locationListHeadline: '600',
    page: '100',
    processItemNumber: '600',
    speechBubble: '600',
    tab: '500',
    textLink: 'bold',
    twoColParagraphStrong: 'bold',
  },
  gaps: {
    factList: `${calcrem(20)} ${calcrem(20)}`,
    jobFactList: '0 1rem',
  },
  headerSpacing: {
    boxShadowOffest: '2px',
    inputCustomHeight: '48px',
    logoHeight: '26px',
    searchBoxFakeHeight: '118px',
    searchBoxFakeHeightWithSearch: '118px',
    searchBoxFakeMarginBottom: '130px',
    searchBoxPaddingBottom: '30px',
    searchBoxPaddingTop: '30px',
    searchIconExtraPadding: '0px',
  },
  heights: {
    brandBarAfter: '0px',
    brandBarAfterWideScreen: '0px',
    checkMark: calcrem(32),
    faqItemOpenElement: '2px',
    input: '55px',
    jobFactItemIconContainer: '45px',
    jobSearchInput: '50px',
    leadFormSectionButton: '80px',
    spacerMax: '2px',
  },
  lineHeights: {
    benefitHeadline: '25px',
    benefitHeadlineWideScreen: calcrem(26),
    buttontext: calcrem(32),
    cardIconText: '22px',
    checkText: calcrem(22),
    checkTextWideScreen: calcrem(24),
    contactParagraph: '18px',
    dateParagraph: calcrem(16),
    dateParagraphWideScreen: calcrem(18),
    errorText: calcrem(17),
    fact: calcrem(70),
    factSubline: calcrem(26),
    faqHeadline: '40px',
    formHead: calcrem(20),
    formHeadWideScreen: calcrem(24),
    headline1: '40px',
    headline1WideScreen: '50px',
    headline2: '40px',
    headline2WideScreen: '38px',
    headline3: '28px',
    headline3WideScreen: '28px',
    headline4: '25px',
    headline4WideScreen: calcrem(26),
    infoText: '20px',
    jobFactItem: '18px',
    jobListTeaser: calcrem(16),
    jobSearchListHeadline: '40px',
    jobSearchListHeadlineWideScreen: '50px',
    label: calcrem(20),
    landingPageParagraph: '24px',
    landingPageParagraphWideScreen: '25px',
    leadFormSectionButton: '30px',
    locationList: '25px',
    logoButtonHeadline: '40px',
    logoButtonHeadlineWideScreen: '40px',
    paragraph: '22px',
    paragraphWideScreen: calcrem(26),
    placeholder: calcrem(20),
    processItemHeadline: '28px',
    processItemNumber: calcrem(20),
    processSubline: '28px',
    processSublineWideScreen: '28px',
    smallButton: '24px',
    speechBubble: '28px',
    subline: '28px',
    sublineWideScreen: '28px',
    tabsModuleHeadlineWideScreen: '40px',
    text: '25px',
    textWideScreen: '22px',
    typographyHeadline2: '28px',
    typographyHeadline2WideScreen: '38px',
  },
  margins: {
    aboutUs: '40px',
    aboutUsHeadline: '2px',
    aboutUsImageContainer: '0 0 20px',
    appForm: '0px',
    appFormWideScreen: '0px',
    appInfo: calcrem(6),
    appInfoWideScreen: calcrem(20),
    applyStepsContainer: `0`,
    applyStepsContainerWideScreen: '0px',
    applyStepsDesktop: '0',
    applyStepsHeadline: '20px',
    applyStepsHeadlineWideScreen: '20px',
    applyStepsSubline: '20px',
    applyStepsSublineWideScreen: '20px',
    backBarLink: '12px',
    benefitCarousel: `0 ${calcrem(-15)} ${calcrem(20)}`,
    benefitHeadline: '20px',
    benefitHeadlineWideScreen: '20px',
    benefitListItems: calcrem(44),
    button: calcrem(20),
    buttonWideScreen: calcrem(24),
    cardIcon: '10px',
    cardIconContainer: '20px',
    checkButton: '1px 10px 0 0',
    checkMark: calcrem(4),
    checkMarkWideScreen: calcrem(1),
    clientLandingPageParagraph: '0px',
    contact: '0 auto 22px auto',
    contactHeadlineBottom: '16px',
    contactLinkList: calcrem(20),
    contactLinkListWideScreen: calcrem(20),
    contactPictureBottom: '16px',
    contactWideScreenBottom: '24px',
    container: '0 auto 50px',
    containerWideScreenBottom: '60px',
    dateBadge: '9px',
    dateParagraph: '18px',
    details: '40px 0',
    errorMessage: '0',
    errorMessageHeading: '0 0 20px -10px',
    errorMessageHeadingWideScreen: '-20px 0 20px -30px',
    errorMessageWideScreen: '0 0 20px 0',
    fact: calcrem(20),
    factHeadline: '20px',
    factHeadlineWideScreen: calcrem(45),
    faqHeadline: '0 0 30px',
    fieldRow: calcrem(14),
    fieldRowWideScreen: calcrem(20),
    fileFieldButton: '25px',
    form: '0px',
    formRow: '0',
    formSection: '0 -10px 20px',
    header: '0 -10px',
    headLine: '0 0 20px',
    headline: calcrem(30),
    headLineBottom: '20px',
    headlineTeaser: '10px',
    iconRight: '4px',
    iconWideScreen: '0 4px 0 0',
    image: '10px',
    imageTeaser: '30px',
    imageTeaserHeadline: '30px',
    imageTeaserParagraph: '20px',
    imageWideScreen: '20px',
    infoText: calcrem(8),
    jobContent: '30px',
    jobDetailsButton: '30px',
    jobFactHelpText: '-5px',
    jobFactList: '35px',
    jobFactListWideScreen: '32px',
    jobList: '20px',
    jobListButtonBottom: '10px',
    jobListButtonLeft: '10px',
    jobListButtonRight: '20px',
    jobListButtonTop: '20px',
    jobListTeaserFooterLeft: '0px',
    jobListTeaserFooterTop: '15px',
    jobListTeaserListItem: '10px',
    jobListTeaserListItemIcon: '15px',
    jobSearchList: '20px',
    landingPageHeadline: '8px',
    landingPageImage: '12px',
    landingPageParagraph: '30px',
    landingPageParagraphWideScreen: '40px',
    linkListHeadline: calcrem(30),
    linkListIcon: '15px',
    list: '0 -20px',
    listItem: `9px 0`,
    locationList: '10px 0 0 30px',
    locationListLi: '10px',
    logoButton: '0 -10px 40px',
    media: '20px',
    modalContent: '0 40px',
    modalContentP: '1em',
    modalContentP1th: '0.5em',
    modalContentP5th: '1em',
    modalFooter: '0 0 40px 40px',
    modalHeader: '40px 0 1em 40px',
    multiMediaAboveline: '0',
    optionContainer: '30px',
    page: '20px',
    pageHead: '30px',
    pageHeadWideScreen: '38px',
    pageWideScreen: '80px',
    paragraphBottom: '20px',
    phoneInput: '0 5px',
    phoneInputWideScreen: '0 15px',
    processCarousel: `0 ${calcrem(-15)} 0`,
    processItem: '0 -10px',
    processItemHeadline: calcrem(6),
    progressBar: '40px',
    searchBoxChildren: '10px',
    searchBoxInput: '20px',
    searchBoxInputWideScreen: '0px',
    secondFooter: calcrem(22),
    secondFooterWideScreen: calcrem(20),
    selectWideScreen: '0',
    sidebarButton: calcrem(30),
    spacer: '0 auto',
    speechBubble: '20px',
    speechBubbleIcon: '2px 10px 0 0',
    statusBar: '20px',
    tab: '10px',
    thankYou: '10px',
    thankYouTeaserImage: '0',
  },
  opacities: {
    buttonHover: '0.3',
  },
  overflows: {
    thankYouTeaser: 'hidden',
  },
  paddings: {
    container: '0 20px',
    defaultButton: '25px 50px',
    fact: calcrem(30),
    factWideScreen: calcrem(30),
    faqItemClose: `${calcrem(26)} ${calcrem(105)} ${calcrem(26)} ${calcrem(75)}`,
    faqItemOpen: `${calcrem(26)} ${calcrem(105)} ${calcrem(46)} ${calcrem(75)}`,
    fieldGroup: `0 ${calcrem(5)}`,
    fieldGroupWideScreen: `0 ${calcrem(15)}`,
    fileUploadHeadline: '0',
    fileUploadHeadlineWideScreen: '0',
    formField: '20px',
    formFieldWideScreen: '20px',
    formSection: '0px',
    formSectionWideScreen: '0px',
    ghostButtonWideScreen: '13px 16px',
    header: `${calcrem(16)} 20px ${calcrem(18)} 0`,
    headerWideScreen: `${calcrem(20)} 20px ${calcrem(24)} 0`,
    imageTeaserWrapper: '20px 0px 20px',
    infoDropDownWideScreen: '0',
    jobFactItem: '15px 0',
    jobFactItemWideScreen: '16px 0',
    jobFactListFirstItem: '0',
    landingPageImg: '0px',
    leadFormSection: '0px',
    leadFormSectionWideScreen: '0px',
    linkgeneratorForm: '40px',
    panel: '0px 10px',
    processItemContainer: `${calcrem(12)} 0px ${calcrem(30)}`,
    processItemContainerWideScreen: `${calcrem(20)} 0 ${calcrem(10)}`,
    progressBarContainer: '0',
    progressBarIcon: '10px 10px 10px 0',
    progressBarIconWideScreen: '10px 10px 10px 0',
    smallButton: '13px 16px',
    spacer: '30px 0',
    thankYou: '0',
    thankYouTeaserStyled: '0',
    twoColParagraph: '0px',
    twoColParagraphBottom: '40px',
    twoColText: '0',
  },
  positions: {
    doneIcon: '10px auto auto 5px',
    doneIconWideScreen: '10px auto auto 10px',
    jobListFooterLineLeft: '0',
    processNumberBottom: '0',
    processNumberBottomWideScreen: '0',
    processNumberLeft: '0',
    processNumberLeftWideScreen: '0',
    speechBubbleAfterBottom: '-10px',
    speechBubbleAfterLeft: '50%',
  },
  radius: {
    aboutUsImg: '5px',
    baseButton: '0px',
    button: '6px',
    cardInfo: '0px',
    checkBox: '0px',
    contactIcon: '50%',
    dateBadge: '8px',
    faqItem: 'none',
    fileField: 'none',
    image: '10px',
    imageTeaser: '10px',
    input: '0px',
    landingPageHeader: '8px',
    link: '6px',
    logoButton: '6px',
    media: '0px',
    mediaWideScreen: '0px',
    pageHead: '0px',
    panel: '0px',
    processItemImage: '0px',
    processNumber: 'none',
    progressBar: '0px',
    radioButton: '24px',
    rounded: '50%',
    smallButton: '0px',
    speechBubbleWrapper: 'none',
    statusBar: '4px',
    tab: '5px 5px 0 0',
    teaser: '0px',
    wrapper: '0px',
  },
  textAligns: {
    applyStepsHeadline: 'left',
    factHeadline: 'left',
    twoColTextHeadline: 'left',
  },
  textDecorations: {
    contactLink: 'undeline',
    location: 'none',
  },
  textShadows: {
    speechBubble: '0 1px 2px rgba(0, 0, 0, 0.22)',
  },
  widths: {
    brandedSpeechBubble: '220px',
    checkMark: calcrem(32),
    contactLinkIcon: 24,
    container: calcrem(1120),
    jobFactItemIconContainer: '45px',
    jobListTeaserFooterLeft: '100%',
    processNumber: '100%',
    spacer: 'calc(100vw - 36px)',
    spacerMax: calcrem(1080),
  },
  zIndex: {
    header: '11',
    inputOverlap: '5',
    modal: '12',
    searchBox: '10',
  },
};
export default defaultTheme;
